<template>
  <span class="role-badge">({{ role }})</span>
</template>
<script>
export default { name: 'RoleBadge', props: { role: String } }
</script>
<style scoped>
/* badge styling */
</style>
